import store from "../redux/store/store.js";
import Transaction from "../models/Transaction.jsx";
import { updateTemporaryTransaction } from "../redux/actions/dashboard.js";

export default class ServerResponseParser {

	static transaction(transactionData) {
		const state = store.getState();
		const { transactionFinder } = state.dashboard;
		let transaction = transactionFinder.getTransactionById(transactionData.id);
		if(!transaction) {
			transaction = transactionFinder.getTransactionBySubmitId(transactionData.submit_id);
		}
		if(transaction) {
			console.log('creating clone of transaction from this data', transactionData);
			store.dispatch(updateTemporaryTransaction(transaction, Transaction.create(transactionData), false));
		}
	}
}